<template>
  <SoAdminPage title="Direct Debit Reviews">
    <template #subtitle>
      <div class="d-flex align-center">
        <span class="mr-1">
          Results for
          <template v-if="reviewId === latestReviewIdQuery.data">
            the latest
          </template>
          payment review ID
        </span>
        <SoSkeleton v-if="!reviewId" width="2em" height="1em" />
        <span v-else class="font-weight-medium">
          {{ reviewId }}
        </span>
      </div>
    </template>

    <template #headerRight>
      <div class="d-flex gap-2">
        <SoSelect
          v-model="reviewIdSelected"
          :items="paymentReviewIdsSelectOptions"
          placeholder="Select a recent review"
          :style="{ width: '250px' }"
          data-testid="direct-debit-review-select"
          @update:model-value="setReviewId(reviewIdSelected)"
        />
        <SoTextField
          v-model="reviewIdInput"
          placeholder="Manually type review ID"
          :hide-details="true"
          :min="1"
          :max="latestReviewIdQuery.data"
          :style="{ minWidth: '150px' }"
          data-testid="direct-debit-review-input"
          @keyup.enter="submitReviewId"
        />
        <SoButton
          type="primary"
          icon="chevron-right"
          large
          data-testid="direct-debit-review-submit"
          @click="submitReviewId"
        />
      </div>
    </template>

    <OpsDirectDebitReviewListTable
      v-if="latestReviewIdQuery.data"
      :payment-review-id="reviewId ? reviewId : latestReviewIdQuery.data"
    />
    <template v-else>
      <SoSkeleton width="100%" height="110px" class="mt-10 mb-14" />
      <SoSkeleton width="100%" height="423px" />
    </template>
  </SoAdminPage>
</template>

<script lang="ts">
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import SoAdminPage from "@/components/templates/SoAdminPage.vue"
  import { defineComponent } from "vue"
  import OpsDirectDebitReviewListTable from "./components/OpsDirectDebitReviewListTable.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import { PaymentReviewService } from "@/services/operations/PaymentReviewService"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import { SoSelectItem } from "@/types/components/SoSelect"

  export default defineComponent({
    components: {
      OpsDirectDebitReviewListTable,
      SoAdminPage,
      SoTextField,
      SoButton,
      SoSkeleton,
      SoSelect,
    },
    data() {
      return {
        reviewId: null as number | null,
        reviewIdInput: null as string | null,
        latestReviewIdQuery: PaymentReviewService.getLatestPaymentReviewId(),
        listOfPaymentReviewIdsQuery: PaymentReviewService.getPaymentReviewIds(),
        reviewIdSelected: null,
      }
    },
    computed: {
      paymentReviewIdsSelectOptions() {
        return this.listOfPaymentReviewIdsQuery.data?.map((item) => {
          return {
            title: item.name,
            value: item.id,
          } as SoSelectItem
        })
      },
    },
    watch: {
      "latestReviewIdQuery.data": {
        handler(newVal: number) {
          if (this.reviewId) return
          this.setReviewId(newVal)
        },
        immediate: true,
      },
    },
    created() {
      if (this.$route.query.reviewId) {
        this.setReviewId(Number(this.$route.query.reviewId))
      }
    },
    methods: {
      setReviewId(id: string | number | null) {
        if (!id) return

        this.reviewId = Number(id)
        this.reviewIdInput = String(id)
        this.$router.replace({ query: { reviewId: id } })
      },
      submitReviewId() {
        this.reviewIdSelected = null
        this.setReviewId(this.reviewIdInput)
      },
    },
  })
</script>
